// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("../DateFns/DateFns.bs.js");
let DateFns$1 = require("date-fns");
let Primitive_object = require("@rescript/runtime/lib/js/Primitive_object.js");

function hours(prim) {
  return DateFns$1.getHours(prim);
}

function minutes(prim) {
  return DateFns$1.getMinutes(prim);
}

function make(hour, minute) {
  return DateFns$1.setMinutes(DateFns$1.setHours(new Date(), hour), minute);
}

let cmp = Primitive_object.compare;

function to12HourString(t) {
  return DateFns$1.format(t, "h:mm aaa");
}

function to24HourString(t) {
  return DateFns$1.format(t, "H:mm");
}

function fromDate(t) {
  return t;
}

function decode(s) {
  return DateFns.parse(s, "h:mm aaa", new Date());
}

let encode = to12HourString;

exports.make = make;
exports.hours = hours;
exports.minutes = minutes;
exports.cmp = cmp;
exports.to12HourString = to12HourString;
exports.to24HourString = to24HourString;
exports.fromDate = fromDate;
exports.encode = encode;
exports.decode = decode;
/* DateFns Not a pure module */
